import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  projectStatus: string | undefined
}

export const ProjectStatusChip: React.FC<ComponentProps> = ({ projectStatus }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (projectStatus === 'INITIATED' || projectStatus === 'PURCHASED_BY_LESSEE') {
    variant = 'outlined'
  } else if (projectStatus === 'COMING_SOON' || projectStatus === 'PROVISIONAL_COMING_SOON') {
    color = 'primary'
    variant = 'outlined'
  } else if (projectStatus === 'OPEN' || projectStatus === 'EARLY_ACCESS') {
    color = 'success'
    variant = 'outlined'
  } else if (projectStatus === 'CLOSED') {
    color = 'warning'
    variant = 'outlined'
  } else if (projectStatus === 'PRODUCTION') {
    color = 'secondary'
    variant = 'outlined'
  } else if (projectStatus === 'REFUNDED' || projectStatus === 'CANCELLED') {
    color = 'error'
    variant = 'outlined'
  }

  return (
    <>
      {projectStatus === undefined
        ? (
          <></>
          )
        : (
            <Tooltip title={projectStatus} TransitionComponent={Zoom} arrow placement='bottom'>
              <Chip label={projectStatus} variant={variant} color={color} />
            </Tooltip>
          )
      }
    </>
  )
}
